// extracted by mini-css-extract-plugin
export var sliderRange = "_pn-2";
export var sliderRoot = "_pn-0";
export var sliderThumb = "_pn-3";
export var sliderTrack = "_pn-1";